module.exports = __webpack_public_path__ + "images/vandusschoten_small4ba17617e6a65259aaee8c06666c84b4.png";